import { render, staticRenderFns } from "./changeInstitution.vue?vue&type=template&id=901458e0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./changeInstitution.vue?vue&type=style&index=0&id=901458e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901458e0",
  null
  
)

export default component.exports